export const banksDummyData = [
    {
        _id: 1,
        name: "ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ",
        swift: "BNGRGRAA",
        country: "GR",
        vatNumber: "094014213",
    },
    {
        _id: 2,
        name: "ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ Α.Ε.",
        swift: "ETHNGRAA",
        country: "GR",
        institute_id: "NBG_ETHNGRAAXXX",
        vatNumber: "094014201",
    },
    {
        _id: 3,
        name: "ΑΛΦΑ ΤΡΑΠΕΖΑ ΑΝΩΝΥΜΟΣ ΕΤΑΙΡΕΙΑ",
        swift: "CRBAGRAA",
        country: "GR",
        institute_id: "ALPHABANK_CRBAGRAA",
        vatNumber: "996807331",
    },
    {
        _id: 4,
        name: "ATTICA BANK, ΑΝΩΝΥΜΗ ΤΡΑΠΕΖΙΚΗ ΕΤΑΙΡΕΙΑ",
        swift: "ATTIGRAA",
        country: "GR",
        institute_id: "ATTICA_ATTIGRAA",
        vatNumber: "094014170",
    },
    {
        _id: 5,
        name: "ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ Α.Ε.",
        swift: "PIRBGRAA",
        country: "GR",
        institute_id: "PIRAEUS_PIRBGRAA",
        vatNumber: "996763330",
    },
    {
        _id: 6,
        name: "ΤΡΑΠΕΖΑ EUROBANK Α.Ε.",
        swift: "ERBKGRAA",
        country: "GR",
        institute_id: "EUROBANK_ERGASIAS_ERBKGRAA",
        vatNumber: "996866969",
    },
    {
        _id: 7,
        name: "ΤΡΑΠΕΖΑ OPTIMA BANK Α.Ε.",
        swift: "IBOGGRAA",
        country: "GR",
        institute_id: "OPTIMA_IBOGGRAA",
        vatNumber: "099369013",
    },
    {
        _id: 8,
        name: "BNP PARIBAS SECURITIES SERVICES",
        swift: "PARBGRAX",
        country: "GR",
    },
    {
        _id: 9,
        name: "AEGEAN BALTIC BANK Α.Τ.Ε.",
        swift: "AEBAGRAA",
        country: "GR",
    },
    {
        _id: 10,
        name: "VIVABANK ΜΟΝΟΠΡΟΣΩΠΗ A.Τ.E.",
        swift: "PRXBGRAA",
        country: "GR",
        institute_id: "PRXBGRAA",
        vatNumber: "999846755",
    },
    {
        _id: 11,
        name: "ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΧΑΝΙΩΝ ΣΥΝ.Π.Ε.",
        swift: "STXAGRA1",
        country: "GR",
    },
    {
        _id: 12,
        name: "HSBC CONTINENTAL EUROPE GREECE",
        swift: "HSBCIE2DXXX",
        country: "GR",
    },
    {
        _id: 13,
        name: "ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΗΠΕΙΡΟΥ ΣΥΝ.ΠΕ.",
        swift: "STIOGR21",
        country: "GR",
    },
    {
        _id: 14,
        name: "BANK OF AMERICA EUROPE DESIGNATED ACTIVITY COMPANY – ATHENS BRANCH",
        swift: "BOFAGR2X",
        country: "GR",
    },
    {
        _id: 15,
        name: "CITIBANK EUROPE PLC (CEP)",
        swift: "CITIGRAA",
        country: "GR",
    },
    {
        _id: 16,
        name: "ΠΑΓΚΡΗΤΙΑ ΤΡΑΠΕΖΑ ΑΝΩΝΥΜΗ ΕΤΑΙΡEΙΑ",
        swift: "STPGGRAA",
        country: "GR",
    },
    {
        _id: 17,
        name: "ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΚΑΡΔΙΤΣΑΣ ΣΥΝ.Π.Ε.",
        swift: "STKAGRA1",
        country: "GR",
    },
    {
        _id: 18,
        name: "ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΘΕΣΣΑΛΙΑΣ ΣΥΝ.Π.Ε.",
        swift: "STTKGR21",
        country: "GR",
    },
    {
        _id: 19,
        name: "ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΟΛΥΜΠΟΣ ΣΥΝ.Π.Ε.",
        swift: "STDRGR21",
        country: "GR",
    },
    {
        _id: 20,
        name: "ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΚΕΝΤΡΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ ΣΥΝ.Π.Ε.",
        swift: "COESGR21",
        country: "GR",
    },
    {
        _id: 21,
        name: "T.C. ZIRAAT BANKASI A.S.",
        swift: "TCZBGRAT",
        country: "GR",
    },
    {
        _id: 22,
        name: "PROCREDIT BANK (BULGARIA) EAD",
        swift: "PRCBGRAA",
        country: "GR",
    },
    {
        _id: 23,
        name: "VIVA ΥΠΗΡΕΣΙΕΣ ΠΛΗΡΩΜΩΝ Α.Ε.",
        swift: "VPAYGRAA",
        country: "GR",
    },
    {
        _id: 24,
        name: "ΤΩΡΑ ΓΟΥΟΛΕΤ ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ ΥΠΗΡΕΣΙΩΝ ΗΛΕΚΤΡΟΝΙΚΟΥ ΧΡΗΜΑΤΟΣ",
        swift: "TWSAGRA1",
        country: "GR",
    },
    {
        _id: 25,
        name: "COSMOTE PAYMENTS ΥΠΗΡΕΣΙΕΣ ΗΛΕΚΤΡΟΝΙΚΟΥ ΧΡΗΜΑΤΟΣ ΑΝΩΝΥΜΟΣ ΕΤΑΙΡΙΑ",
        swift: "CPEMGRA2",
        country: "GR",
        vatNumber: "800995166",
    },
    {
        _id: 26,
        name: "REVOLUT",
        swift: "REVOLT21XXX",
        country: "GR",
        institute_id: "REVOLUT_REVOLT21",
    },
    {
        _id: 26,
        name: "AIRWALLEX",
        swift: "AIPTAU32",
        country: "GR",
        institute_id: "AIRWALLEX_EEA_AIPTAU32",
    },
    {
        _id: 27,
        name: "BUNQ",
        swift: "BUNQNL2A",
        country: "GR",
        institute_id: "BUNQ_BUNQNL2A",
    },
    {
        _id: 28,
        name: "EBURY",
        swift: "EBPTGR21XXX",
        country: "GR",
        institute_id: "EBURY_EBPTGR21XXX",
    },
    {
        _id: 29,
        name: "FINOM",
        swift: "FNOMDEB2",
        country: "GR",
        institute_id: "FINOM_FNOMDEB2",
    },
    {
        _id: 30,
        name: "FINOM",
        swift: "FNOMDEB2",
        country: "GR",
        institute_id: "FINOM_FNOMDEB2",
    },
    {
        _id: 31,
        name: "LUNAR",
        swift: "LUNADK22",
        country: "GR",
        institute_id: "LUNAR_LUNADK22",
    },
    {
        _id: 32,
        name: "MONESE",
        swift: "MNEEBEB2",
        country: "GR",
        institute_id: "MONESE_MNEEBEB2",
    },
    {
        _id: 33,
        name: "N26 BANK",
        swift: "NTSBDEB1XXX",
        country: "GR",
        institute_id: "N26_NTSBDEB1",
    },
    {
        _id: 34,
        name: "NETELLER",
        swift: "NETEGB21",
        country: "GR",
        institute_id: "PAYSAFE_NETEGB21",
    },
    {
        _id: 35,
        name: "PAYPAL",
        swift: "PPLXLULLXXX",
        country: "GR",
        institute_id: "PAYPAL_PPLXLULL",
    },
    {
        _id: 36,
        name: "PAYSERA",
        swift: "EVIULT21XXX",
        country: "GR",
        institute_id: "PAYSERA_EVIULT21XXX",
    },
    {
        _id: 37,
        name: "SKRILL",
        swift: "SKRLGB2L",
        country: "GR",
        institute_id: "PAYSAFE_SKRLGB2L",
    },
    {
        _id: 38,
        name: "SOLDO",
        swift: "SFSDIE22",
        country: "GR",
        institute_id: "SOLDO_SFSDIE22",
    },
    {
        _id: 39,
        name: "STRIPE",
        swift: "STPUIE21",
        country: "GR",
        institute_id: "STRIPE_STPUIE21",
    },
    {
        _id: 40,
        name: "SWAN",
        swift: "SWNBFR22",
        country: "GR",
        institute_id: "SWAN_SWNBFR22",
    },
    {
        _id: 41,
        name: "VIVID",
        swift: "VVIDLUL2",
        country: "GR",
        institute_id: "VIVID_VVIDLUL2",
    },
    {
        _id: 42,
        name: "WISE",
        swift: "TRWIGB22XXX",
        country: "GR",
        institute_id: "WISE_EEA_TRWIGB22",
    },
    {
        _id: 10000,
        name: "SANDBOX",
        swift: "SANDBOX",
        country: "GR",
        institute_id: "SANDBOXFINANCE_SFIN0000",
    },
]

export const bankOptions = banksDummyData.map((bank) => {
    return {
        label: bank.name,
        value: bank.swift,
    }
})

export const extendedBankOptions = [...bankOptions, {label: "Λοιπές Τράπεζες / Μη Καθορισμένες", value: "OTHER"}]
